const COLOR = {
  sent:      "#9ca3af",  // grey — one tick
  delivered: "#9ca3af",  // grey — two ticks
  read:      "#3b9eed",  // blue — two ticks
};
 
export default function TickIcon({ status = "sent" }) {
  const color = COLOR[status] || COLOR.sent;
  const double = status === "delivered" || status === "read";
 
  return (
    <svg
      width={double ? 18 : 11}
      height={10}
      viewBox={double ? "0 0 18 10" : "0 0 11 10"}
      fill="none"
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      {/* First tick */}
      <path
        d="M1 5l3 3L10 1"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Second tick (delivered / read) */}
      {double && (
        <path
          d="M6 5l3 3 5-7"
          stroke={color}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}